import React from 'react';
import { Configuration } from '../../../../configs/Configuration';

export default function HeaderMain(props){
    const configuration = Configuration.getConfiguration();
    const logoClass = configuration.logoCssClass;
    const logoUrl = props.configs.data.standalone_page_logo_url ? props.configs.data.standalone_page_logo_url : props.configs.data.dashboard_logo_url;
    return(
      <div className="utility-header">
        <div className="utility-header-container">
          <div className="utility-logo">
          {logoUrl && (
            <img className={logoClass} src={logoUrl} alt="logo"/>
          )}
          </div>
        </div>
      </div>
    );
}
